<div
  [class.hidden]="!showDatePickerWrapper"
  class="saas-ui date-picker-wrapper"
  [ngClass]="containerClass">
  <label (click)="toggleCalendarComponent($event)" class="date-range-label">
    {{ label }}
    <!--    if compared is off and selection is not custom check if auto (start/end) option is selected,
            if so show auto and value of start/end date,
            if not show regular start and end date-->
    <div
      #calendarInput
      class="input-wrapper"
      [style.width]="datePickerInputWidth || null"
      [style.height]="datePickerInputHeight || null">
      <input
        type="text"
        [class]="datePickerInputStyleClass"
        readonly
        [value]="getDatePickerLabel()"
        [attr.size]="getDatePickerLabel().length || 10" />
      <i
        class="material-symbols-outlined calendar-icon text-blue-600"
        aria-hidden="true">
        calendar_today
      </i>
    </div>
  </label>
  <label *ngIf="compareEnabled" class="compare" for="compareSwitchOutSide">
    Compare
    <p-inputSwitch
      id="compareSwitchOutSide"
      class="compare-switch mt-1"
      [(ngModel)]="compareToggledOn"
      (onChange)="
        toggleCompare($event.checked); openCalendar()
      "></p-inputSwitch>
  </label>
</div>
<p-dialog
  header="Title"
  [(visible)]="showCalendar"
  appendTo="body"
  [styleClass]="'date-picker-popup'"
  [showHeader]="false"
  [modal]="true"
  [focusTrap]="true"
  (onHide)="cancel()"
  [transitionOptions]="'0ms'">
  <div
    #calendarPopup
    class="date-picker-popup-content"
    [ngClass]="{ 'position-static': pageCentered }">
    <div
      class="left-side saas-ui saas-ui-size-default"
      [ngClass]="{ compare: compareToggledOn && compareToggledOn }">
      <div class="left-side-content">
        <div class="date-picker-title">
          <span class="sh2 text-gray-1000">Date presets</span>
        </div>

        <div class="date-picker-info-bar">
          <i
            class="material-symbols-outlined icon-small text-gray-500"
            aria-hidden="true">
            info
          </i>
          <span class="c1 text-gray-800">{{ availabilityInfoText }}</span>
        </div>

        <div class="range-picker-section">
          <p-dropdown
            *ngIf="showPresetSelection"
            [options]="currentRangeOptions"
            [(ngModel)]="selectedOption"
            class="b1 text-gray-1000"
            [autofocus]="true"
            (onChange)="
              changeDateRangeOption(asCurrentDropdownOption($event.value).name)
            ">
            <ng-template pTemplate="selectedItem" let-option>
              {{ option.label || option.name }}
            </ng-template>
            <ng-template pTemplate="item" let-option>
              {{ option.label || option.name }}
            </ng-template>
          </p-dropdown>
          <div *ngIf="showInputPickers" class="date-inputs-row">
            <input
              pInputText
              (change)="
                applyFromInputField(
                  asInputElement($event.target).value,
                  'startDate'
                )
              "
              (focus)="onInputFocus($event, 'startDate')"
              (blur)="onInputBlur($event, 'startDate')"
              [disabled]="disableStartDate"
              type="text"
              class="date-input"
              [(ngModel)]="startDate" />
            <span class="b1 text-gray-1000">-</span>
            <input
              pInputText
              type="text"
              (change)="
                applyFromInputField(
                  asInputElement($event.target).value,
                  'endDate'
                )
              "
              (focus)="onInputFocus($event, 'endDate')"
              (blur)="onInputBlur($event, 'endDate')"
              [disabled]="disableEndDate"
              class="date-input"
              [(ngModel)]="endDate" />
          </div>
          <div class="col-md-12 text-red" *ngIf="isOutOfDateRange">
            Maximum allowed duration is {{ allowedDuration }} days
          </div>
          <div class="bulk-mode" *ngIf="dateFilter && dateFilter.bulkModeValue">
            <label class="input-label">
              Select by
              <p-dropdown
                [options]="bulkModeOptions"
                class="b1 text-gray-1000"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="selectedBulkMode"
                (onChange)="updateDateBasedOnBulkMode()"></p-dropdown>
            </label>
          </div>
        </div>

        @if (compareEnabled) {
          <div class="compare-section" [class.compare]="compareToggledOn">
            <div class="input-switch">
              <label for="compareSwitch">
                <p-inputSwitch
                  id="compareSwitch"
                  class="compare-toggle"
                  [(ngModel)]="compareToggledOn"
                  (onChange)="toggleCompare($event.checked)">
                </p-inputSwitch>
                <span class="toggle-text">Compare with</span>
              </label>
            </div>
            @if (compareToggledOn) {
              <p-dropdown
                [options]="compareRangeOptions"
                [(ngModel)]="selectedCompareOption"
                class="b1 text-gray-1000"
                (onChange)="
                  changeCompareDateRangeOption(
                    asCompareDropdownOption($event.value).name
                  )
                ">
                <ng-template pTemplate="selectedItem" let-option>
                  {{ option.label || option.name }}
                </ng-template>
                <ng-template pTemplate="item" let-option>
                  {{ option.label || option.name }}
                </ng-template>
              </p-dropdown>
              <div class="date-inputs-row">
                <input
                  pInputText
                  type="text"
                  (change)="
                    applyFromInputField(
                      asInputElement($event.target).value,
                      'startDateCompare'
                    )
                  "
                  (focus)="onInputFocus($event, 'startDateCompare')"
                  (blur)="onInputBlur($event, 'startDateCompare')"
                  class="date-input"
                  [(ngModel)]="startCompareDate" />
                <span class="b1 text-gray-1000">-</span>
                <input
                  pInputText
                  type="text"
                  (change)="
                    applyFromInputField(
                      asInputElement($event.target).value,
                      'endDateCompare'
                    )
                  "
                  (focus)="onInputFocus($event, 'endDateCompare')"
                  (blur)="onInputBlur($event, 'endDateCompare')"
                  class="date-input"
                  [(ngModel)]="endCompareDate" />
              </div>
            }
          </div>
        }

        @if (showApplyForAll) {
          <div class="ms-3 d-flex gap-0">
            <m-checkbox
              [isChecked]="isApplyForAllChecked"
              [binary]="true"
              (onChange)="
                isApplyForAllChecked = !isApplyForAllChecked
              "></m-checkbox>
            <span>Apply to All Rows</span>
          </div>
        }
      </div>

      <div class="date-picker-footer d-flex gap-3 mt-auto">
        <button
          [disabled]="isApplyButtonDisabled"
          pButton
          class="p-button p-button-primary"
          (click)="apply()"
          label="Save"></button>
        <button
          pButton
          class="p-button p-button-outlined"
          (click)="cancel()"
          label="Cancel"></button>
      </div>
    </div>
    <!--regular date range pick-->
    <div class="calendar-side single" *ngIf="!compareToggledOn && showCalendar">
      <drp-daterangepicker
        class="w-100"
        [calendarDisabled]="disableStartDate && disableEndDate"
        *ngIf="showCalendarComponent"
        [autoApply]="true"
        [linkedCalendars]="true"
        [bulkSelection]="
          dateFilter && dateFilter.bulkModeValue
            ? !!dateFilter.bulkModeValue
            : false
        "
        [selectionMode]="selectedBulkMode"
        [selectionSize]="1"
        [focusOnEndDate]="disableStartDate"
        (choosedDate)="selectCurrentDateFromCalendar(asDateRange($event))"
        [startDate]="selected.startDate"
        [lockStartDate]="disableStartDate"
        [lockEndDate]="disableEndDate"
        [endDate]="selected.endDate"
        [minDate]="minDate"
        [maxDate]="disableEndDate ? psuedoMaxEndDate : maxDate"
        [locale]="locale">
      </drp-daterangepicker>
    </div>
    <!--regular date range pick-->
    <!--compare pick calendars-->
    <div
      class="calendar-side multiple"
      *ngIf="compareToggledOn && showCalendar">
      <div class="d-flex flex-column gap-3 align-items-center">
        <drp-daterangepicker
          class="left-calendar"
          *ngIf="showCalendarComponent"
          [autoApply]="true"
          [linkedCalendars]="false"
          [startDate]="selected.startDate"
          (datesUpdated)="selectCurrentDateFromCalendar(asDateRange($event))"
          [endDate]="selected.endDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [locale]="locale">
        </drp-daterangepicker>
        <p class="calendar-label">Current Time Period</p>
      </div>
      <div class="separator"></div>

      <div class="d-flex flex-column gap-3 align-items-center">
        <drp-daterangepicker
          class="secondary"
          *ngIf="showCalendarComponent"
          [autoApply]="true"
          (datesUpdated)="selectCompareDateFromCalendar(asDateRange($event))"
          [startDate]="selectedCompare.startDate"
          [endDate]="selectedCompare.endDate"
          [minDate]="minDate"
          [maxDate]="selected.startDate.subtract(1, 'day')"
          [locale]="locale">
        </drp-daterangepicker>
        <p class="calendar-label">Comparison Time Period</p>
      </div>
    </div>
    <!--compare pick calendars-->
  </div>
</p-dialog>
